(function($){
$(document).ready(function() {

	$('.slider-actus').slick({
	    autoplay: false,
	    arrows: false,
	    dots: true,
	    infinite: false,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    // fade: true,
	    cssEase: 'ease-out',
	    // responsive: [
	    //   {
	    //     breakpoint: 1240,
	    //     settings: {
	    //       arrows: false,
	    //       dots: true,
	    //     }
	    //   }
	    // ]
	});

}); // document.ready
})(jQuery);
